<template>
  <div id="leadMManager">
    <transition name="component-transition" mode="out-in">
      <component v-bind:is="view" @changeView="changeView" @closeSlideout="closeSlideout" v-bind="dynamicProps" @showLoader="showLoader" @hideLoader="hideLoader"></component>
    </transition>
    <loader :showLoader="showLoaderDiv"></loader>
  </div>
</template>

<script>
/* global globalConfig loggedUserDetails sso */

import mpLeadForm from './mponly-lead-form'
import leadFormLogin from './login'
import leadFormOTP from './otp-verification'
import loader from '../loader'
import step2 from './lead-submit-step-2'
import thankYou from './thank-you.vue'

export default {
  components: {
    mpLeadForm,
    leadFormLogin,
    leadFormOTP,
    loader,
    step2,
    thankYou
  },
  props: ['destination', 'leadFormMessage'],
  data: function() {
    return {
      view: 'mpLeadForm',
      showLoaderDiv: false,
      dynamicProps: {},
      formSubmitError: false
    }
  },
  methods: {
    changeView: function(data) {
      this.view = data.viewName
      if (data.props) {
        this.dynamicProps = data.props
      }
    },
    closeSlideout: function() {
      this.$emit('closeSlideout')
    },
    showLoader: function() {
      this.showLoaderDiv = true
    },
    hideLoader: function() {
      this.showLoaderDiv = false
    }
  },
  created: function() {
    let usrLoggedIn = sso.isUserLoggedIn()
    this.dynamicProps = {}
    this.dynamicProps.isMPForm = globalConfig.isMarketplaceOnlyPackages
    this.dynamicProps.leadFormMessage = this.leadFormMessage
    this.dynamicProps.destination = this.destination
    this.dynamicProps.showSubmitError = false
    this.preFillData = null
    if (usrLoggedIn) {
      this.dynamicProps.user = loggedUserDetails
    }
  }
}
</script>

<style lang="scss">
@import '../../sass/partials/variables';

.component-transition-enter-active,
.component-transition-leave-active {
  transition: all 0.3s ease;
}

.component-transition-leave-to {
  opacity: 0;
}

.component-transition-enter {
  opacity: 0;
  transform: translateX(100%);
}

.component-transition-leave {
  transform: translateX(-100%);
}

.desktopCalendar {
  width: 100%;
}

#leadMManager {
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/lead-form/lead-manager.vue